import React from 'react';
import { Form } from '@rocketseat/unform';
import logo from '~/assets/Logo Apolar-pretaeazul01.png';
import history from '~/services/history';

import { Content } from './styles';

export default function SucessRegister() {
  async function handleSubmit() {
    history.push('/');
  }

  return (
    <Content>
      <img src={logo} alt="Logo Apolar Imóveis" />

      <Form onSubmit={handleSubmit}>
        <h5>Dados Gravados</h5>
        <div className="inputSucessRegister">
          Em breve um de nossos atendentes entrará em contato com você.
        </div>

        <button type="submit">Login</button>
      </Form>
    </Content>
  );
}
